/*
| The screen registry: one key per first URL segment.
|
| Every entry is a dynamic import, so a screen's code (and Chart.js) loads the
| first time someone visits it. A screen exports
| `default async function ({ arg, render, api, config, links })` and returns HTML.
*/

import { esc } from '../lib/format.js';

const lazy = (load) => async (context) => (await load()).default(context);

/** Inline, so the fallback never depends on a chunk that could fail to load. */
function notFound() {
  return `<div class="pagehead"><div>
      <h1>Not found</h1>
      <p>No page matches <span class="mono">${esc(window.location.pathname)}</span>.</p>
    </div></div>
    <div class="note">Try the <a href="/overview" style="color:var(--accent)">overview</a>, or search for a market, builder, token, wallet or transaction with <span class="kbd">/</span>.</div>`;
}

export const screens = {
  overview: lazy(() => import('./overview.js')),
  analytics: lazy(() => import('./analytics.js')),
  builders: lazy(() => import('./builders.js')),
  markets: lazy(() => import('./markets.js')),
  addresses: lazy(() => import('./addresses.js')),
  tokens: lazy(() => import('./tokens.js')),
  transfers: lazy(() => import('./transfers.js')),
  liquidations: lazy(() => import('./liquidations.js')),
  notFound,
};
